var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotificationgray = function SvgNotificationgray(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4016 12.4615V7.84615C12.4016 5.01231 10.9057 2.64 8.29705 2.01231V1.38462C8.29705 0.618462 7.67681 0 6.91976 0C6.1627 0 5.5607 0.618462 5.5607 1.38462V2.01231C2.94293 2.64 1.45617 5.00308 1.45617 7.84615V12.4615L0.270422 13.6523C-0.304212 14.2338 0.09712 15.2308 0.908904 15.2308H12.9215C13.7333 15.2308 14.1437 14.2338 13.5691 13.6523L12.4016 12.4615ZM6.91976 18C7.92309 18 8.74399 17.1692 8.74399 16.1538H5.09552C5.09552 17.1692 5.90731 18 6.91976 18Z",
    fill: "#696593"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationgray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "notificationgray.ed874929c427c089a7ab07a69dcf35ee.svg";